<template>
  <form @submit.prevent="submit" class="tenant-form uk-form-stacked">
    <form-fieldset :legend="$t('fieldsets.base')">
      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.name"
        :label="$t('fields.name')"
        ref="name"
        v-model="fields.values.name"
      />
      <checkbox
        :disabled="!isEditable"
        :errors="fields.errors.active"
        :label="$t('fields.active')"
        v-model="fields.values.active"
      />
    </form-fieldset>

    <form-fieldset
      :legend="$t('fieldsets.organizations')"
      class="uk-margin-top"
    >
      <organization-manager
        :default-organization-errors="fields.errors.defaultOrganization"
        :default-organization.sync="fields.values.defaultOrganization"
        :disabled="!isEditable"
        :organizations-errors="fields.errors.organizations"
        :organizations.sync="fields.values.organizations"
      />
    </form-fieldset>

    <form-fieldset :legend="$t('fieldsets.colorPalette')">
      <color-manager
        :errors="fields.errors.colors"
        v-model="fields.values.colors"
      />
    </form-fieldset>

    <submit-button :disabled="!isSubmittable" type="primary" />
    <cancel-button />
  </form>
</template>

<script>
import CancelButton from '@/components/CancelButton';
import Checkbox from '@/components/Checkbox';
import ColorManager from '@/components/ColorManager';
import Form from '@/mixins/Form';
import FormFieldset from '@/components/FormFieldset';
import OrganizationManager from '@/components/OrganizationManager';
import SubmitButton from '@/components/SubmitButton';
import TextInput from '@/components/TextInput';

export default {
  name: 'tenant-form',
  components: {
    CancelButton,
    Checkbox,
    ColorManager,
    FormFieldset,
    OrganizationManager,
    SubmitButton,
    TextInput,
  },
  mixins: [
    Form({
      name: { required: true },
      active: { default: true },
      colors: { type: Form.Types.Array },
      organizations: { type: Form.Types.ReferenceList },
      defaultOrganization: { type: Form.Types.Reference },
    }),
  ],
  mounted() {
    this.$refs.name.focus();
  },
  i18n: {
    messages: {
      de: {
        fieldsets: {
          base: 'Basisdaten',
          colorPalette: 'Farbpalette',
          organizations: 'Vertriebsorganisationen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// TenantForm.vue?327c352e